import { BaseControl } from '..';
import { SelectControl } from '../SelectControl';
import { NumberControl } from '../NumberControl';

/**
 * @typedef {object} AnimationControlOptions
 */

/**
 * @typedef {'none' | 'slide-from-top' | 'slide-from-bottom' | 'fade-in'} AnimationType
 */

/**
 * @typedef {object} AnimationControlValue
 * @property {AnimationType} type - Which entry animation to play
 * @property {number} duration - Animation duration in ms
 * @property {number} delay - Animation delay in ms
 */

/**
 * @extends {BaseControl<AnimationControlValue, AnimationControlOptions>}
 */
export class AnimationControl extends BaseControl {

    /**
     * @param {import('..').BaseControlDefinition<AnimationControlValue, AnimationControlOptions>} control
     */
    constructor(control) {
        super(control);

        this.children = {
            'type': new SelectControl({
                label: 'Animatie',
                description: 'Hoe deze container in beeld verschijnt wanneer je er naartoe scrolt',
                defaultValue: 'none',
                options: {
                    choices: [
                        { value: 'none', label: 'Geen' },
                        { value: 'slide-from-top', label: 'Van boven' },
                        { value: 'slide-from-bottom', label: 'Van onder' },
                        { value: 'fade-in', label: 'Fade in' },
                    ],
                },
            }),
            'duration': new NumberControl({
                label: 'Duur (ms)',
                description: 'Hoe lang de animatie duurt',
                defaultValue: 600,
                options: {},
            }),
            'delay': new NumberControl({
                label: 'Vertraging (ms)',
                description: 'Wachttijd voordat de animatie start',
                defaultValue: 0,
                options: {},
            }),
        };
    }
}
